import { FETCH_USERS, FetchUsers } from './types';

// eslint-disable-next-line import/prefer-default-export
export const fetchUsers = (): FetchUsers => ({
  type: FETCH_USERS,
});
